/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { __decorate } from "tslib";
// Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
import { customElement } from 'lit/decorators.js';
import { RippleBase } from './mwc-ripple-base.js';
import { styles } from './mwc-ripple.css.js';
/** @soyCompatible */
let Ripple = class Ripple extends RippleBase {
};
Ripple.styles = [styles];
Ripple = __decorate([
    customElement('mwc-ripple')
], Ripple);
export { Ripple };
//# sourceMappingURL=mwc-ripple.js.map